import { setShowSupplierItemModal } from '../State/showSupplierItemModal';
import { setSupplierItemForEdit } from '../State/supplierItemForEdit';

export default () => async (dispatch) => {
  dispatch(setSupplierItemForEdit(null));
  dispatch(setShowSupplierItemModal(true));
}
